export default{
    install(Vue){
        
        //配置信息
        var $winConfig = {
            isLogin: false,
            uid: '',
            shareConfig:{
                url: "http://5sing.kugou.com/subject/mdkt2018/index",
                title: '爱在无风时-美的空调原创音乐征集大赛',
                image: "http://static.5sing.kugou.com/topic/mdkt2018/images/share.png",    
                description: "美的空调爱在无风时原创音乐大赛10强闪亮登场！",
                description4Wsing: "美的空调爱在无风时原创音乐大赛10强闪亮登场！(活动地址：[url=http://5sing.kugou.com/subject/mdkt2018/index]点击进入[/url])"
            },
            //报名配置信息
            // activityId : "W/Zuabg+nPM=",  //测试
            // voteColumnId : "unl8Kv7rl8g=",
            // signConfig:[
            //     {
            //         text: "原唱",
            //         id: "jyZM/nw9yzY=",
            //         type: "yc",
            //     },
            //     {
            //         text: "视频",
            //         id: "TFHGScOBeU4=",
            //         type: "mv",
            //     },
            //     {
            //         text: '翻唱',
            //         id: "SAPIE5WqSdA=",
            //         type: "fc",
            //     }
            // ],
            activityId : "3wLDLMmG8N4=",  //正式
            voteColumnId : "UIjWcGDj/3A=",
            signConfig:[
                {
                    text: "原唱",
                    id: "MzOF40Tiyxs=",
                    type: "yc",
                },
                {
                    text: "视频",
                    id: "jBPqO/q1XB4=",
                    type: "mv",
                },
                {
                    text: '翻唱',
                    id: "T/KYeQOyDoc=",
                    type: "fc",
                }
            ],
            //视频配置信息
            videoConfig: {
                width: '800',
                height: '450',
                videoList: [
                    // {
                    //     src: "http://fx.v.kugou.com/G108/M09/07/04/DIcBAFvhFX6AeDIJAFMQIjv9Sqc683.mp4",
                    //     name: "#爱在无风时#羽泉导师收官祝福",
                    //     screenshort: "http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video4_m.jpg",
                    //     poster: 'http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video4.jpg'
                    // },
                    // {
                    //     src: "http://fx.v.kugou.com/G135/M00/06/18/xw0DAFtMS2KATEOJAMGzJGVt9x4914.mp4",
                    //     name: "#爱在无风时#羽泉",
                    //     screenshort: "http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video_m1.jpg",
                    //     poster: 'http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video1.jpg'
                    // },
                    {
                        src: "http://fx.v.kugou.com/G131/M00/06/09/Y5QEAFtMTAmABN7xAF8w2If7c2M878.mp4",
                        name: "#爱在无风时#宣传片",
                        screenshort: "http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video_m2.jpg",
                        poster: 'http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video2.jpg'
                    },
                    {
                        src: "http://fx.v.kugou.com/G133/M05/1E/09/xQ0DAFtFuraAQHXVAcZzqnhzVv0397.mp4",
                        name: "#在无风的时光遇见你#宣传片",
                        screenshort: "http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video_m.png",
                        poster: 'http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/video.png'
                    }
                ]
            }
        };

        Vue.winConfig = Vue.prototype.$winConfig = $winConfig;
    }
}


// WEBPACK FOOTER //
// ./src/components/config.js